import { defineMessages } from 'react-intl';

export default defineMessages({
	previewPanelCloseButtonLabel: {
		id: 'navigation.preview-panel.preview-panel-header.close-button-label',
		defaultMessage: 'Close',
		description: 'Label for the close button in the preview panel',
	},
	previewPanelExpandActionLabel: {
		id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label',
		defaultMessage: 'Expand',
		description: 'Label for the expand action in the preview panel',
	},
	previewPanelNewTabActionLabel: {
		id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label',
		defaultMessage: 'Open in new tab',
		description: 'Label for the open in new tab action in the preview panel',
	},
	previewPanelMoreDropdownActionLabel: {
		id: 'navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label',
		defaultMessage: 'More',
		description: 'Label for the more dropdown action in the preview panel',
	},
	previewPanelOpenInNewWindowLabel: {
		id: 'navigation.preview-panel.preview-panel-header.open-in-new-window-label',
		defaultMessage: 'Open in new window',
		description: 'Label for the open in new window button in the preview panel header',
	},
});
